import styled from "styled-components";
import { motion } from "framer-motion";

export const ContainerSelectorCircuito = styled.div`
  width: 100%;
  height: 100vh;
  height: 100dvh;
  @media (min-width: 1000px) {
    display: none;
  }
`;

export const TextSelectorCircuito = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 20%;
  .title-saludo {
    font-weight: 400;
    font-size: 24px;
    line-height: 150%;
    text-align: center;
    width: 365px;
  }
`;

export const BtnContainerSelectorCircuito = styled.div`
  padding-top: 50px;
  height: calc(100% - 22vh);
  height: calc(100% - 22dvh);
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;
  gap: 30px;
  svg {
    width: 25px;
    height: 25px;
  }
  overflow-y: scroll;
  ::-webkit-scrollbar {
    width: 10px;
  }

  ::-webkit-scrollbar-thumb {
    -webkit-border-radius: 10px;
    border-radius: 10px;
    background: var(--color-scrollbar);
  }
  .ptur-socialSidebar-burguer {
    width: 100%;
    position: initial;
    padding-top: 20px;
  }
`;

export const HeaderSelectorCircuitoBar = styled.div`
  position: relative;
  width: 100%;
  height: 100px;
  margin: auto;
  color: var(--color-white);
  background-color: var(--color-latex10);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-top: 4px solid var(--color-primary);
  text-align: center;
  .title {
    font-weight: 400;
    font-size: 20px;
    line-height: 150%;
    font-style: normal;
  }
  .title-negrita {
    font-weight: 700;
    font-size: 20px;
    line-height: 150%;
    font-style: normal;
  }
  ${({ $isTerminal }) =>
    $isTerminal &&
    `
    .title {
    font-size: 22px;
    }
    .title-pregunta {
    font-weight: 400;
    font-size: 22px;
    line-height: 150%;
    text-align: center;
  }

  .title-negrita {
    font-size: 22px;
    font-weight: bold;
  }
  `}

  .arrow {
    font-size: 40px;
    position: absolute;
    left: 0;
    padding-left: 10px;
  }
  h1 {
    padding: 0;
    margin: 0;
    text-align: center;
  }
  .container-ellipse {
    width: 100%;
    height: max-content;
    /* background-color: red; */
    position: absolute;
    bottom: -50%;
    margin: auto;
    right: 0;
  }
`;

export const ContianerSelectorCircuito = styled(motion.div)`
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  background-color: transparent;
  .redirection {
    position: absolute;
    height: max-content;
    width: max-content;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    padding-bottom: 20px;
    @media (max-height: 780px) {
      padding-bottom: 0px;
      height: 80px;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: -1;
    }
  }
  .logo-dim {
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: -2;
  }

  ::-webkit-scrollbar {
    width: 0;
  }
  .selected {
    background-color: red;
  }
  .ptur-socialSidebar-burguer {
    width: 100%;
    position: initial;
    padding-top: 20px;
  }
`;
